<template>
    <div class="border-b border-[#eeeff2] mb-1.5 py-3">
        <span class="block text-[20px] font-[CircularBook] text-center">Coin Information</span>
    </div>
    <div class="flex flex-wrap gap-[20px] items-start px-5 py-3.5">
        <div class="relative overflow-x-auto border border-[#eeeff2] rounded-[7px] flex-[260px]">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap">
                <tbody class="text-[12px] font-[CircularBook] text-[#2a395a]">
                <tr class="bg-white text-left border-b border-[#eeeff2]">
                    <td class="px-3 text-[14px] py-1 border-r border-[#eeeff2]">
                        Name
                    </td>
                    <td class="px-3 py-1 text-right text-[#a4a6aa]">
                        {{currency.name}}
                    </td>
                </tr>
                <tr class="bg-white text-left border-b border-[#eeeff2]">
                    <td class="px-3 text-[14px] py-1 border-r border-[#eeeff2]">
                        Short Name
                    </td>
                    <td class="px-3 py-1 text-right text-[#a4a6aa]">
                        {{currency.slug}}
                    </td>
                </tr>
                <tr class="bg-white text-left border-b border-[#eeeff2]">
                    <td class="px-3 text-[14px] py-1 border-r border-[#eeeff2]">
                        System
                    </td>
                    <td class="px-3 py-1 text-right text-[#a4a6aa]">
                        {{info.system}}
                    </td>
                </tr>
                <tr class="bg-white text-left">
                    <td class="px-3 text-[14px] py-1 border-r border-[#eeeff2]">
                        Max Supply
                    </td>
                    <td class="px-3 py-1 text-right text-[#a4a6aa]">
                        {{info.max_supply}}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="relative overflow-x-auto border border-[#eeeff2] rounded-[7px] flex-[260px]">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap">
                <tbody class="text-[12px] font-[CircularBook] text-[#2a395a]">
                <tr class="bg-white text-left border-b border-[#eeeff2]">
                    <td class="px-3 text-[14px] py-1 border-r border-[#eeeff2]">
                        Website
                    </td>
                    <td class="px-3 py-1 text-right text-[#366fed]">
                        <a :href="`${info.website}`" target="_blank">{{info.website}}</a>
                    </td>
                </tr>
                <tr class="bg-white text-left border-b border-[#eeeff2]">
                    <td class="px-3 text-[14px] py-1 border-r border-[#eeeff2]">
                        Explorer
                    </td>
                    <td class="px-3 py-1 text-right text-[#366fed]">
                        <a :href="`${info.explorer}`" target="_blank">{{info.explorer}}</a>
                    </td>
                </tr>
                <tr class="bg-white text-left border-b border-[#eeeff2]">
                    <td class="px-3 text-[14px] py-1 border-r border-[#eeeff2]">
                        Coinmarketcap
                    </td>
                    <td class="px-3 py-1 text-right text-[#366fed]">
                        <a :href="`${info.cmc}`" target="_blank">{{info.cmc}}</a>
                    </td>
                </tr>
                <tr class="bg-white text-left border-b border-[#eeeff2]">
                    <td class="px-3 text-[14px] py-1 border-r border-[#eeeff2]">
                        Social
                    </td>
                    <td class="px-3 py-1 text-right text-[#366fed]">
                        <a :href="`${info.social}`" target="_blank">{{info.social}}</a>
                    </td>
                </tr>
                <tr class="bg-white text-left">
                    <td class="px-3 text-[14px] py-1 border-r border-[#eeeff2]">
                        Chat
                    </td>
                    <td class="px-3 py-1 text-right text-[#366fed]">
                        <a :href="`${info.chat}`" target="_blank">{{info.chat}}</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script setup>
const currency = pageData.market.from_cgw_currency;
const info = currency.currency_info
</script>
